/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(public dialog: MatDialog) {}

  open<TData extends object>(options: {
    component: ComponentType<unknown> | TemplateRef<unknown>;
    config?: MatDialogConfig<TData>;
    fullscreen?: boolean;
  }): MatDialogRef<any, any> {
    const { component, config } = options;
    const dialogRef = this.dialog.open(component, {
      disableClose: true,
      ...(options.fullscreen && {
        panelClass: ['mat-dialog-custom-full-screen'],
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw'
      }),
      ...config
    });

    return dialogRef;
  }

  openSheet<TData extends object>(
    component: ComponentType<unknown> | TemplateRef<unknown>,
    config?: MatDialogConfig<TData>
  ): MatDialogRef<any, any> {
    return this.open({
      component,
      config: {
        panelClass: ['mat-dialog-custom', 'drawer', 'slide-in-right'],
        backdropClass: 'dialog-backdrop',
        ...config,
        disableClose: true
      }
    });
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
